import Modal, { bind } from './Modal.svelte';
export default Modal;
export { Modal, bind };
